import classnames from 'classnames';
import { __ } from '@wordpress/i18n';
const { useState, useEffect, useRef } = wp.element;

function StyleGrid(props) {
	const {
		content_limit,
		icon_type,
		col_style,
		content_visibility,
		data,
		slider_options,
		sliderSettings,
		count_after_text,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile
	} = props;

	const colClasses = classnames([
		'swiper',
		'rtcl-gb-cat-wrap',
		'rtcl-gb-slider-pagination-style-' + slider_options["dotStyle"],
		'rtcl-gb-slider-btn-style-' + slider_options["arrowPosition"]
	]);

	const itemContainerClass = classnames([
		'listing-item',
		'rtcl-gb-cat-box',
		'rtcl-gb-cat-box-' + col_style["style"],
		content_visibility['contentAlign']
	]);

	//slider initialize
	const sliderReff2 = useRef(null);
	const rtcl_gb_caterory_slider2 = function (sliderE, sliderOptions) {
		let options = Object.assign({}, sliderOptions);
		if (sliderE.swiper) {
			sliderE.swiper.destroy();
		}
		new Swiper(sliderE, options);
	};
	useEffect(() => {
		rtcl_gb_caterory_slider2(sliderReff2.current, sliderSettings);
	}, [slider_options, col_xl, col_lg, col_md, col_sm, col_mobile, content_visibility]);

	return [
		data.length ? (
			<div className="rtcl rtcl-gb-block rtcl-gb-slider-main-wrap">
				<div ref={sliderReff2} className={colClasses}>
					<div className="swiper-wrapper">
						{data.map((catlist, index) => (
							<div className="swiper-slide" key={index}>
								<div className={itemContainerClass}>

									<div className="rtcl-box-head">
										{content_visibility["icon"] && catlist.icon_html ?
											<div className={icon_type == 'icon' ? 'item-icon' : 'item-image'}> <a href={catlist.permalink} dangerouslySetInnerHTML={{ __html: catlist.icon_html }}></a>	</div> : ''}
										<div className="item-content">
											<h3 className="title"><a href={catlist.permalink} dangerouslySetInnerHTML={{ __html: catlist.name }}></a></h3>
											{content_visibility["counter"] && catlist.count ? <div className="counter">{!count_after_text ? catlist.count == 1 ? catlist.count + __(' Ad') : catlist.count + __(' Ads') : catlist.count + ' ' + count_after_text}</div> : ''}
										</div>
									</div>

									{(catlist.child_html || catlist.description) ?
										<div className="rtcl-box-body">
											{content_visibility["subCat"] && catlist.child_html ? <ul className="rtcl-sub-cats" dangerouslySetInnerHTML={{ __html: catlist.child_html }}></ul> : ''}
											{content_visibility["catDesc"] && catlist.description ? <p className="content">{`${catlist.description.split(' ', content_limit).join(' ') + '....'}`}</p> : ''}
										</div>
										: ''}

								</div>
							</div>
						))}
					</div>
					{slider_options["arrowNavigation"] &&
						<>
							<span className="rtcl-gb-slider-btn button-left rtcl-icon-angle-left"></span>
							<span className="rtcl-gb-slider-btn button-right rtcl-icon-angle-right"></span>
						</>
					}
					{slider_options["dotNavigation"] && <div className="rtcl-gb-slider-pagination"></div>}

				</div>
			</div>
		) : '',

	]

}
export default StyleGrid;